import { useProfileModalVariant } from '@/hooks/theme/variants/useProfileModalVariant';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import dynamic from 'next/dynamic';

const StaticsCardV1 = dynamic(() => import('./V1').then(mod => mod.default), {
  ssr: true,
});

const StaticsCardV2 = dynamic(() => import('./V2').then(mod => mod.default), {
  ssr: true,
});

export default function StaticsCardRenderer() {
  const { version } = useProfileModalVariant();

  switch (version?.toString()) {
    case SettingLayoutComponentId.UserProfileV1?.toString():
    default:
      return <StaticsCardV1 />;
    case SettingLayoutComponentId.UserProfileV2?.toString():
      return <StaticsCardV2 />;
  }
}
